import { useLingui } from '@lingui/react';
import { useLocation } from 'react-router-dom';
import PdfPreview from '../../Molecules/Document/PdfPreviewNew';
import { IconX } from '@tabler/icons';
import { ActionIcon, Group } from '@mantine/core';

const EmailDocumentAttachment = ({ eventId, attachment, deleteAtIndex, index }) => {
  const { i18n } = useLingui();
  const { pathname } = useLocation();

  if (!pathname.includes('emails')) {
    attachment.fileName = i18n._(`document.${attachment.documentType.toLowerCase()}`);
  }

  return (
    <Group
      noWrap
      p="xs"
      spacing="xs"
      sx={(theme) => ({
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
      })}
    >
      {!pathname.includes('emails') && <PdfPreview file={attachment} eventId={eventId} />}

      {/* 
      <div style={styles.fileName}>{attachment.fileName}</div> */}

      {!pathname.includes('emails') && (
        <div style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {attachment.templateName && <div>Vorlage: {attachment.templateName}</div>}
        </div>
      )}

      {deleteAtIndex && (
        <ActionIcon size="xs" sx={{ flex: '0 0 auto' }}>
          <IconX onClick={() => deleteAtIndex(index)} />
        </ActionIcon>
      )}
    </Group>
  );
};

export default EmailDocumentAttachment;
